import { NotificationsActions } from '../actions/notifications.actions';


export interface INotificationsState {

}

const initialState: INotificationsState = <INotificationsState>{

};

export function notificationsReducer (state: INotificationsState = initialState, action: NotificationsActions): INotificationsState {
  switch (action.type) {
    default:
      return {
        ...state
      };
  }
}

